import { createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../..";
import { setPunchInStatus } from "../loginUserSlice";
import { AUTH_LOGIN, AUTH_RESET_PASSWORD, GET_USER_DETAILS } from "../../Queries/Users";
import { setMailList } from "../notification";
import { getAllClientsData } from "../loginUserSlice";
import { SetAllEmployees } from "../employeeslice";
import { setAllUsers } from "../loginUserSlice";
import { FETCH_ALL_USERS } from "../../Queries/Users";
import { GET_DYNAMIC_ROUTES } from "../../Queries/options";
import { setempRoute } from "../DyanamicRoute";
import { RESET_TOKEN } from "../../Queries/ResetToken";
import { UPDATE_PUNCHOUT } from "../../Queries/attendence";
import { getProgress, setAllRecords, setAttendence, setNewRecord, setTotalRecords } from "../attendenceSlice";
import { message } from "antd";
import { ATTENDENCE } from "../../Queries/attendence";
import { GET_ALL_RECORDS } from "../../Queries/attendence";
// useElapsedTime import removed — React hooks cannot be used in thunks
import { setLoader } from "../loaderSlice";
import { GET_LAST_ATTENDENCE_RECORD } from "../../Queries/attendence";
import { updateEmployee } from "./employeeThunk";
import { CREATE_LOGINWORKHISTORY, CREATE_WORKHISTORY } from "../../Queries/Orders";
import { fetchEmails } from "../sharedEmailSlice";
import { LoginMessgae,UpdateLoginTime } from "../timerslice";

export const fetchUserDetails = createAsyncThunk(
  "user/fetchUserDetails",
  async (userId, { dispatch, rejectWithValue , getState}) => {
    try {
      dispatch(setLoader(true));
        //  const cleanUserId = typeof userId === "string"
        // ? userId.replace(/"/g, "").trim()
        // : userId;
      const { data } = await client.mutate({
        mutation: GET_USER_DETAILS,
        variables: { id: userId },
      });

      const loginData = data?.getUserDetails[0];
      if (!loginData) return;
      dispatch(setPunchInStatus(loginData?.punchInStatus))
      if (loginData?.punchInStatus) {
        dispatch(fetchLastAttendanceRecord({ userId: loginData?.id }))
        dispatch(getAllClientsData(loginData?.client))
      }
      await dispatch(fetchEmails());  
      const personalMail = loginData?.email;
      const mails = loginData?.emailSettings
        ?.filter(item => item.status === true || item.status === "true")
        ?.map(item => item.email) || [];

      const salesMails = loginData?.salesEmailSettings
        ?.filter(item => item.status === true || item.status === "true")
        ?.map(item => item.email)
        ?.filter(Boolean) || [];

      // EMails from Shared Email to the user
      const sharedEmails = loginData?.sharedemailSettings;
      const sharedemails = getState().sharedEmail?.sharedemails;

      // Create a map for faster lookup
      const emailMap = sharedemails?.reduce((acc, item) => {
        acc[item._id] = item.email;
        return acc;
      }, {}) || {};

      // Filter and map to actual emails
      const sharedMails = sharedEmails
        ?.filter(item => item.status === true || item.status === "true")
        ?.map(item => emailMap[item.email]) // replace ID with actual email
        ?.filter(Boolean); // remove any undefined in case of unmatched IDs

      const uniqueMails = Array.from(new Set([...mails, ...salesMails, personalMail, ...sharedMails]));

      if (uniqueMails?.length > 0) {
        dispatch(setMailList(uniqueMails));
      }
      return loginData;
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      return rejectWithValue(error.message);
    }
    finally{
      dispatch(setLoader(false));
    }
  }
);


export const fetchAllUsersThunk = createAsyncThunk(
  "users/fetchAllUsers",
  async (userId, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true));
      const { data } = await client.mutate({
        mutation: FETCH_ALL_USERS,
        variables: { loginUserId: userId }
      });

      const usersContent = data?.fetchAllUsers || [];
      const usersList = usersContent.response || [];

      dispatch(SetAllEmployees(usersList));
      dispatch(setAllUsers(usersList));
      return usersList;
    } catch (error) {
      console.error("Error fetching all users:", error);
      return rejectWithValue(error.message);
    }
    finally{
dispatch(setLoader(false));
    }
    
  }
);

export const fetchDynamicRoutes = createAsyncThunk(
  "routes/fetchDynamicRoutes",
  async (isLoggedIn, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_DYNAMIC_ROUTES,
        skip: !isLoggedIn,
        fetchPolicy: "network-only",
      });

      const sideMenu = data?.getSideMenu || [];
      dispatch(setempRoute(sideMenu));

      return sideMenu;
    } catch (error) {
      console.error("Error fetching dynamic routes:", error);
      return rejectWithValue(error.message);
    }
  }
);
export const resetTokenThunk = createAsyncThunk(
  "auth/resetToken",
  async (email, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: RESET_TOKEN,
        variables: { email },
      });
      if (data.ResetToken.success === true) {
        message.success(`Token Reset Successful and sent to Mail`);
      } else {
        message.error(data?.ResetToken?.message || "Failed to reset token.");
      }

      return data;
    } catch (error) {
      console.error("Reset token error:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const fetchLastAttendanceRecord = createAsyncThunk(
  "attendance/fetchLastRecord",
  async ({ userId }, { dispatch, rejectWithValue }) => {
    if (!userId) return;

    try {
      const { data } = await client.query({
        query: GET_LAST_ATTENDENCE_RECORD,
        variables: { id: userId },
        fetchPolicy: "network-only",
      });

      const lastAttendance = data?.LastAttendence?.response;
      dispatch(setAttendence(lastAttendance));
      localStorage.setItem("punchInTime", parseInt(lastAttendance?.punchIn));
      dispatch(setAttendence(lastAttendance))
      return lastAttendance;
    } catch (error) {
      console.error("Error fetching last attendance record:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const attendenceLoginThunk = createAsyncThunk(
  "attendance/login",
  async ({ empId, punchIn }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: ATTENDENCE,
        variables: {
          input: {
            empId,
            punchIn,
            status: true,
            elapsedTime: 0,
          },
        },
      });

      await dispatch(updateEmployee({ id: empId, input: { punchInStatus: true } }))
      const newAttendance = data.AttendenceLogin.response;
      dispatch(setNewRecord(newAttendance));
      dispatch(setAttendence(newAttendance));
      dispatch(setPunchInStatus(true))
      localStorage.setItem("punchInTime", newAttendance?.punchIn);
      const isPunchedIn = true;
      // useElapsedTime removed — it's a React hook and cannot be called inside a thunk.
      // The component-level useElapsedTime in AttendenceEmployee.jsx handles the timer.
      return data?.Attendence;
    } catch (error) {
      console.error("Attendance punch-in failed:", error);
      return rejectWithValue(error.message);
    } finally {
      dispatch(setLoader(false));
    }
  }
);

export const attendanceUpdateAsync = createAsyncThunk(
  'employee/updateStatus',
  async ({ empid, id, input }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true))
      const { data } = await client.mutate({
        mutation: UPDATE_PUNCHOUT,
        variables: { id, input },
      });
      await dispatch(updateEmployee({ id: empid, input: { punchInStatus: false } }))
      dispatch(fetchAllRecordsAsync({ userId: empid }));
       dispatch(getProgress({ id: empid }));
       dispatch(setAttendence({}));
      dispatch(setPunchInStatus(false))
      // useElapsedTime removed — React hooks cannot be called inside thunks.
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update employee status');
    } finally {
      dispatch(setLoader(false));
    }
  }
);

export const fetchAllRecordsAsync = createAsyncThunk(
  'attendance/fetchAllRecords', async ({ userId, date, page, pageSize }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true));
      const { data } = await client.query({
        query: GET_ALL_RECORDS,
        variables: { id: userId, date, page, pageSize },
        fetchPolicy: 'network-only',
      })
      dispatch(setAllRecords(data?.AllAttendence?.response))
      dispatch(setTotalRecords(data?.AllAttendence?.totalRecords || 0));
      return data?.AllAttendence?.response
    }
    catch (error) {
      console.error('failed to getallrecords', error.message)
      return rejectWithValue(error.message)
    }
    finally {
      dispatch(setLoader(false));
    }
  }
)
export const createLoginWorkHistoryAsync = createAsyncThunk(
  'login/createLoginWorkHistory',
  async (workHistoryPayload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_LOGINWORKHISTORY,
        variables: workHistoryPayload,
      });

      const response = data?.createLoginWorkHistory;
      dispatch(UpdateLoginTime(response.startTime))
            
                      localStorage.setItem('LoginTime', new Date(response.startTime).getTime())
      // Check if response exists and includes a message
      if (response?.message) {
        dispatch(LoginMessgae(response.message));
      }

      return response;
    } catch (error) {
      console.error("Error creating login work history:", error);
      return rejectWithValue(error?.message || "Failed to create login work history");
    }
  }
);

export const authLoginThunk = createAsyncThunk(
  'auth/login',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: AUTH_LOGIN,
        variables: { email, password },
        fetchPolicy: 'no-cache',
      });

      const authLogin = data?.authLogin;

      if (!authLogin || authLogin.status !== 200) {
        return rejectWithValue(authLogin?.message || 'Invalid login');
      }

      const token = authLogin.token;

      return {
        token,
        response: authLogin.response,
        message: authLogin.message,
      };
    } catch (error) {
      console.error('Login thunk error:', error);
      return rejectWithValue(error?.message || 'Login failed');
    }
  }
);

export const authResetPasswordThunk = createAsyncThunk(
  'login/resetPassword', async ({ email, token, password, isPasswordGenerated }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: AUTH_RESET_PASSWORD,
        variables: { email, token, password, isPasswordGenerated }
      })
      const authReset = data.createpassword
      return {
        status: authReset.status,
        message: authReset.message
      }
    }
    catch (error) {
      console.error('reset password thunk error:', error);
      return rejectWithValue(error?.message || 'reset password  failed');
    }
  }
);

export const createWorkHistoryThunk = createAsyncThunk(
  "login/creareWorkhistory",
  async (workHistoryPayload, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_WORKHISTORY,
        variables: workHistoryPayload,
        fetchPolicy: "no-cache",
      });

      return data?.createWorkHistory;
    } catch (error) {
      console.error("Error create work history:", error);
      return rejectWithValue(error?.message || "Failed to create work history");
    }
  }
);
